var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"id":"mri-results-content"}},[_c('MriResultsText',{class:'subtitle'}),[_c('MriDefaultContent',{attrs:{"data":_vm.copyData[_vm.year],"year":_vm.year}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }